'use strict';

wbApp.factory('surveySvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var Survey = $resource('/Api/Surveys/GetAll', {}, {
            'query': { method: 'GET', isArray: true },
            'insert': { method: 'POST', url: '/Api/Surveys/Insert' },
            'update': { method: 'POST', url: '/Api/Surveys/Update' },
            'delete': { method: 'POST', url: '/Api/Surveys/Delete' },

        });

        var surveys;

        function newModel() {
            var survey = new Survey();
            survey.active = true;
            survey.isDefault = false;
            survey.maxContactsPerClient = 3;
            survey.surveyQuestions = [newQuestion()];
            return survey;
        }

        function newQuestion() {
            return {
                surveyQuestionTypeID: 1,
                allowCustomNote: true,
                weight: 100
            };
        }

        function getAllAsync() {
            if (!surveys) {
                surveys = repositorySvc.get(Survey, {});
            }
            return surveys;
        }

        function getDefaultAsync() {
            var all = getAllAsync();

            return $q(function (resolve, reject) {
                all.$promise.then(function (data) {
                    resolve(_.find(data, { isDefault: true, active: true, isDeleted: false }));
                }, function (reason) {
                    reject(reason);
                });
            });
        }

        function getAllNonDeleted(refresh) {
            var models = getAllAsync(refresh);
            var filteredModels = [];

            var deferred = $q.defer();
            filteredModels.$promise = deferred.promise;

            models.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (!value.isDeleted) {
                        filteredModels.push(value);
                    }
                });
                deferred.resolve(filteredModels);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filteredModels;
        }

        function getAllActiveAsync(IDtoInclude) {
            var models = getAllAsync();
            var filteredModels = [];

            var deferred = $q.defer();
            filteredModels.$promise = deferred.promise;

            models.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if ((!value.isDeleted && value.active) || value.surveyID === IDtoInclude) {
                        filteredModels.push(value);
                    }
                });
                deferred.resolve(filteredModels);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filteredModels;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                Survey,             // $resource
                surveys,            // collection
                data,               // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                Survey,            // $resource
                surveys,           // collection
                data,              // entity
                successCallback,
                errorCallback,
                'surveyID');
        }

        function remove(data, errorCallback) {
           return repositorySvc.remove(
                Survey,             // $resource
                surveys,            // collection
                data,               // entity
                null,               // successCallback
                errorCallback,
                null,
                'surveyID');
        }

        return {
            newModel: newModel,
            getAllAsync: getAllAsync,
            getAllNonDeleted: getAllNonDeleted,
            getAllActiveAsync: getAllActiveAsync,
            insert: insert,
            update: update,
            remove: remove,
            newQuestion: newQuestion,
            getDefaultAsync: getDefaultAsync
        }
    }
]);